import { integer, pgTable, text, timestamp, unique, index, foreignKey } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { tag } from './tags';
import { adminUser } from './admin';
import { tagTargetType } from './enums';

export const tagAssignment = pgTable('TagAssignment', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  tagId: integer().notNull(),
  targetType: tagTargetType().notNull(),
  targetId: integer().notNull(),
  source: text().notNull().default('manual'),
  assignedBy: integer(),
  // Канал, через который тег был навешан (для UTM-атрибуции).
  // Значения: 'bot' | 'miniapp' | 'web' | null (для тегов вне UTM-флоу).
  channel: text(),
  // ID Telegram-бота для channel='bot'|'miniapp'. NULL для channel='web' или вне UTM.
  botId: integer(),
  assignedAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  unique('TagAssignment_tag_target_unique').on(table.tagId, table.targetType, table.targetId),
  index('TagAssignment_target_idx').on(table.targetType, table.targetId),
  index('TagAssignment_tagId_idx').on(table.tagId, table.targetType),
  index('TagAssignment_channel_idx').on(table.channel),
  foreignKey({ columns: [table.tagId], foreignColumns: [tag.id] }).onDelete('cascade'),
  foreignKey({ columns: [table.assignedBy], foreignColumns: [adminUser.id] }).onDelete('set null'),
]);
